import React from 'react';
import { Button, Col, Form, FormProps, Input, Row, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { evaluationsQuestionsStatus } from 'constants/admin/evaluations';

export const SearchFilters: React.FC<{
  searchFormProps: FormProps;
}> = ({ searchFormProps }) => {
  const handleClear = () => {
    searchFormProps.form?.resetFields();
    searchFormProps.form?.submit();
  };

  return (
    <Form {...searchFormProps} layout="inline" className="mb-4 w-full">
      <Row gutter={[16, 16]} className="w-full">
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="statement">
            <Input
              placeholder="Buscar enunciado..."
              suffix={<SearchOutlined />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item name="status">
            <Select
              placeholder="Todos os status"
              options={evaluationsQuestionsStatus}
              defaultValue={null}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={6}>
          <Form.Item>
            <Space className="w-full">
              <Button type="default" htmlType="submit">
                Filtrar
              </Button>
              <Button type="text" onClick={handleClear}>
                Limpar filtro
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
